{
  "ru": {
    "publicOffer": {
      "title": "Публичная оферта"
    }
  },
  "kk": {
    "publicOffer": {
      "title": "Жария оферта"
    }
  },
  "en": {
    "publicOffer": {
      "title": "Public offer"
    }
  }
}
